













































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import * as moment from "moment";
import { PostModel, PostsApi, PutPostRequest } from "../../../apis";

@Component({
  components: {},
})
export default class ReviewLicense extends Vue {
  headerImageHeight = "100%";

  get currentLocale() {
    return this.$store.getters.locale;
  }

  get isVn() {
    return this.currentLocale === "vn";
  }

  get isEn() {
    return this.currentLocale === "en";
  }

  get license() {
    return this.$store.getters.license as PostModel;
  }

  beforeDestroy() {
    this.$store.commit("SET_LICENSE", {});
  }

  async updateLicense() {
    try {
      this.$util.showLoading();
      await new PostsApi().updatePost({
        id: this.license.id,
        putPostRequest: {
          id: this.license.id,
          contentEn: this.license.contentEn,
          contentVn: this.license.contentVn,
        } as PutPostRequest,
      });
      this.$router.push({ name: "license" });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
